
// vertex shader that places the model on the specified position
// with the specified rotation and scale.
export const vertex = `
precision highp float;

attribute vec2 uv;
attribute vec2 vertex_position;

attribute vec4 color;
attribute vec2 scale;
attribute vec2 position;
attribute float rotation;

uniform mat4 projection;

varying vec2 v_uv;
varying vec4 v_color;

void main() {
    v_uv = uv;
    v_color = color;

    float c = cos(rotation);
    float s = sin(rotation);
    mat2 rotationMatrix = mat2(c, -s, s, c);

    vec2 scaledPos = vertex_position * scale;
    vec2 rotatedPos = rotationMatrix * scaledPos;
    vec2 finalPosition = rotatedPos + position;

    gl_Position = projection * vec4(finalPosition, 0.0, 1.0);
}
`;

// fragment shader that draws the whole texture in the given color, alpha values of 0 get ignored
// using premultiplied alpha
export const fragment = `
precision highp float;

uniform sampler2D texture;

varying vec2 v_uv;
varying vec4 v_color;

void main() {
    vec4 sample = texture2D(texture, v_uv);
    gl_FragColor = vec4(v_color.rgb * sample.a, sample.a);
}
`;